import * as PIXI from 'pixi.js'

import { startLoop } from 'macguffin/Utils/Loop'
import { Textures, Animations } from './devTools'
import Sagas from './redux/sagas'
import Components from './components'
import * as Utils from './utils'

import { Spine } from 'pixi-spine'

if (Spine) {
  PIXI.spine = {
    get Spine() {
      if (console.log) {
        console.log('Deprecated spine call, please import "Spine" from "pixi-spine" directly!')
        console.log((new Error()).stack)
      }
      return Spine
    }
  }
}

/**
 * Overloads the update property of spine prototype
 * to take into consideration the speed of the PIXI shared ticker.
 * This allows the shared ticker to adjust the speed of which the spine
 * animation is played at.
 */
const origUpdate = Utils.McSpine.prototype.update
const origUpdateTransform = PIXI.Container.prototype.updateTransform
Utils.McSpine.prototype.update = function newUpdate(tickerDeltaTime) {
  origUpdate.call(this, (tickerDeltaTime * PIXI.Ticker.shared.speed))
}

/**
 * Fixes a bug caused by spines updating after being destroyed
 * This should really be in pixijs, it's such an obvious thing...
 */
Utils.McSpine.prototype.updateTransform = function newTransform(...theArgs) {
  if (this.transform) {
    origUpdateTransform.call(this, ...theArgs)
  }
}

PIXI.Ticker.shared.autoStart = false
PIXI.Ticker.shared.stop()

let rendered = true
let timer

window.addEventListener('resize', () => {
  timer && clearTimeout(timer)
  rendered = false
  timer = setTimeout(() => !rendered && PIXI.Ticker.shared.update(), 200)
})

startLoop(() => {
  PIXI.Ticker.shared.update()
  !rendered && (rendered = true)
})

/**
 * Main object that exposes all functionality present in mc_pixi *
 */
module.exports = {
  ...Components,
  ...Utils,
  devTools: [ Textures, Animations ],
  Sagas,
  PIXI,
}
